function VideoAssets() {
  this.videoControllers = {};
  this.videoPromises = {};
}

VideoAssets.prototype.loadVideos = function (videos, api) {
  const videoPromises = [];
  videos.forEach( (video) => {
    if (this.videoPromises[video]) {
      this.claimVideoController(video);
      videoPromises.push(this.videoPromises[video]);
    } else {
      const url = api.makeVideoUrl(video);

      //const el = document.querySelector("#hax");
      const lol = document.createElement('div');
      lol.innerHTML = `
        <video src="${url}" muted loop controls width="150" height="150" playsinline autoplay crossOrigin="anonymous" />
      `
      const v = lol.firstElementChild;
      v.crossOrigin = "anonymous";
      v.src = url;
      //el.appendChild(v)

      //const counter = document.createElement('div');
      //counter.innerHTML = "0"
      //el.appendChild(counter);


      const data = {
        video,
        //el:v,
        last:new Date().getTime(),
        claims:0,
        controller:v,
        //counter
      }
      this.videoControllers[video] = data;

      this.claimVideoController(video);

      const prm = new Promise( (resolve,reject) => {
        v.oncanplaythrough = () => {
          setTimeout( () => {
            data.videoTexture = PIXI.Texture.from(v);
            resolve(data);
          }, 0);
        }
        v.onerror = () => {
          reject();
        }
      });

      this.videoPromises[video] = prm;

      videoPromises.push(this.videoPromises[video]);

    }

  });

  return videoPromises;

}

VideoAssets.prototype.clearVideoControllers = function () {
  Object.keys(this.videoControllers).forEach( (k) => {
    const {claims, last, controller, videoTexture, el, counter} = this.videoControllers[k];
    const now = new Date().getTime();
    if (claims <= 0) {
      controller.pause();
      if (now - last > 1000) {
        videoTexture.destroy();
        /*
        try {
          el.parentNode.removeChild(el);
          counter.parentNode.removeChild(counter);
        } catch (e) {
        }
        */
        delete this.videoControllers[k];
        delete this.videoPromises[k];
      }
    }
  });
}


VideoAssets.prototype.loadVideo = function () {
}

VideoAssets.prototype.sweepVideoControllers = async function (videoPromises) {
  await Promise.all(videoPromises.map( async videoPromise => {
    const data = await videoPromise
    this.releaseVideoController(data.video);
  }));
  this.clearVideoControllers();
}

VideoAssets.prototype.claimVideoController = function (video) {
  this.videoControllers[video].claims++;
  //this.videoControllers[video].counter.innerHTML = "" + this.videoControllers[video].claims;
  this.videoControllers[video].last = new Date().getTime();
  return this.videoControllers[video];
}

VideoAssets.prototype.getVideoController = function (video) {
  return this.videoControllers[video];
}


VideoAssets.prototype.releaseVideoController = function (video) {
  this.videoControllers[video].last = new Date().getTime();
  this.videoControllers[video].claims--;
  //this.videoControllers[video].counter.innerHTML = "" + this.videoControllers[video].claims;
}

export default VideoAssets;
